import { createElement } from "react";
import { HOME_PATH } from "@routes/path";
import type { AppRoute } from "@routes/types";
import HomePage from "@pages/home";
import AppShellLayout from "@components/ui/layout/AppShellLayout";
import type { RouteObject } from "react-router-dom";

const routes: AppRoute[] = [
    {
        path: HOME_PATH,
        element: createElement(HomePage),
        label: "Home",
    },
    {
        path: "/",
        element: createElement(HomePage),
        label: "",
    }
];

const HomeRoute: RouteObject[] = [{
                element: createElement(AppShellLayout),
                children: routes
            }];

export default HomeRoute;